import React, { useState } from "react";
//import * as _ from "lodash";
import Months, { MONTH_CODES } from "./ui/Months";
import { pad2 } from "./QuizDay";
import Logo from "./ui/Logo";
import Footer from "./ui/Footer";

import { numToNth } from "./util/util";

import { getIsUsa, getVisits } from "./util/settings";
import {
  getLocaleLongWeekday,
  getLocaleLongMonth,
  getLocaleIsRtl,
} from "./util/localisation";

import "./Learn.css";

export const getYearCode = (n) => {
  const d = n % 100;
  const c = 1 + ((3 - (Math.floor(n / 100) % 4)) % 4) * 2;
  return (c + d + Math.floor(d / 4)) % 7;
};

export const getCenturyCode = (year) => ((getYearCode(year) + 1) % 7) - 1;

const TipsView = () => (
  <div className="Learn">
    <Tips />
  </div>
);

const CenturyTable = ({ includeCompact, onChange }) => {
  const [expandedLevel, setExpandedLevel] = useState(includeCompact ? 0 : 1);

  const COLLAPSED_YEARS = [1900, 2000];
  const EXP_1 = [1500, 1600, 1700, 1800, ...COLLAPSED_YEARS];
  const EXP_2 = [...EXP_1, 2100, 2200, 2300, 2400, 2500, 2600];

  const centuryTips =
    expandedLevel === 0 ? COLLAPSED_YEARS : expandedLevel === 1 ? EXP_1 : EXP_2;

  const canExpaned = expandedLevel < 2;

  const onClick = () => {
    const level = (expandedLevel + 1) % 3 || (includeCompact ? 0 : 1);
    setExpandedLevel(level);
    if (onChange) {
      onChange(level);
    }
  };

  return (
    <table className="Centuries -tipTable">
      <thead>
        <tr>
          <th>Century</th>
          <th>#</th>
        </tr>
      </thead>
      <tbody onClick={onClick}>
        {centuryTips.map((year) => (
          <tr key={year}>
            <td className="-year">{year}s</td>
            <td className="-num">{getCenturyCode(year)}</td>
          </tr>
        ))}
        <tr>
          <td colSpan="2" className="-showMore">
            <strong>Show {canExpaned ? "more" : "less"}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

const YearCalcTableBody = ({ remoev28s }) => {
  const [year, setYear] = useState(0);

  const rotateExample = () => {
    while (true) {
      let test;
      if (!year) {
        test = 1911 + Math.floor(Math.random() * 17);
      } else {
        test = 1901 + Math.floor(Math.random() * 199);
      }
      if (
        test % 100 !== year % 100 &&
        test % 100 !== 0 &&
        Math.floor(test / 100) !== Math.floor(year / 100)
      ) {
        setYear(test);
        return;
      }
    }
  };

  const yearCalc = year && getYearCalculation(year, remoev28s);

  return (
    <tbody onClick={rotateExample}>
      <tr>
        <td colSpan={2}>Last two digits = x</td>
      </tr>
      <tr>
        <td colSpan={2}>
          # = x + RoundDown(x/4)
          <br />
          ...then century rule
          <br />
          ...then remove 7s
        </td>
      </tr>
      {year !== 0 && (
        <tr>
          <td colSpan={2}>
            eg. <b>{yearCalc.year}</b>
            {yearCalc.yearSubtract > 0 && (
              <i>
                {" "}
                (subtract {yearCalc.yearSubtract})<br />
                {yearCalc.newYear}
              </i>
            )}{" "}
            ~ {pad2(yearCalc.digits)} + [{pad2(yearCalc.digits)}/4]
            <br />= {yearCalc.digits} + {yearCalc.digitsDivideBy4} ={" "}
            {yearCalc.digitsSum}
            <br />
            ... +{yearCalc.centuryNum} for {yearCalc.century}s = {yearCalc.sum}
            <br />
            ... remove 7s = <b>{yearCalc.answer}</b>
          </td>
        </tr>
      )}
      {
        <tr>
          <td colSpan="2" className="-showMore">
            <strong>{year ? "New" : "Show"} example</strong>
          </td>
        </tr>
      }
    </tbody>
  );
};

const getYearTips = (year, expandedLevel) => {
  const minYear = expandedLevel === 0 ? year - 2 : year - 8;
  const maxYear = expandedLevel === 0 ? year + 1 : year + 2;

  const yearTips = [];
  for (let y = minYear; y <= maxYear; y++) {
    yearTips.push(y);
  }

  return yearTips;
};

const YearTableBody = ({ year }) => {
  /*const [expandedLevel, setExpandedLevel] = useState(0);

  const canExpaned = expandedLevel < 1;
  */
  const expandedLevel = 0;
  const yearTips = getYearTips(year, expandedLevel);

  return (
    <tbody>
      {/* onClick={() => setExpandedLevel((expandedLevel + 1) % 2)}>*/}
      {yearTips.map((year) => (
        <tr key={year}>
          <td className="-year">{year}</td>
          <td className="-num">{getYearCode(year)}</td>
        </tr>
      ))}
      {/*
      <tr>
        <td colSpan="2" className="-showMore">
          <strong>Show {canExpaned ? "more" : "less"}</strong>
        </td>
      </tr>
    */}
    </tbody>
  );
};

const isLeapYear = (year) =>
  year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);

const getYearCalculation = (year, remove28s) => {
  let yearSubtract = 0;
  let newYear = year;
  if (remove28s) {
    yearSubtract = Math.floor((year % 100) / 28) * 28;
    newYear -= yearSubtract;
  }

  const digits = newYear % 100;
  const century = Math.floor(newYear / 100) * 100;
  const digitsDivideBy4 = Math.floor(digits / 4);
  const centuryNum = getCenturyCode(century);
  const digitsSum = digits + digitsDivideBy4;
  const sum = digitsSum + centuryNum;
  return {
    year,
    yearSubtract,
    newYear,
    digits,
    digitsDivideBy4,
    digitsSum,
    century,
    centuryNum,
    sum,
    answer: sum % 7,
  };
};

const TipSheet = ({ year, isShown, setShown }) => {
  const toggleShow = (evt) => {
    evt.preventDefault();
    setShown(!isShown);
  };

  return (
    <div className="-tipSheet">
      <button type="button" onClick={toggleShow}>
        {isShown ? "☒ Hide" : "☐ Show"}
        <br />
        Tip&nbsp;Sheet
      </button>
      <Logo />
      {isShown && (
        <>
          <Months />
          <div className="-cols">
            <div>
              <CenturyTable includeCompact />

              <table className="Years -tipTable">
                <thead>
                  <tr>
                    <th>Year</th>
                    <th>#</th>
                  </tr>
                </thead>
                <YearTableBody year={year} />
              </table>
            </div>

            <div>
              <table className="YearAlgo -tipTable">
                <thead>
                  <tr>
                    <th>Years</th>
                  </tr>
                </thead>
                <YearCalcTableBody />
              </table>

              <table className="LeapYears -tipTable">
                <thead>
                  <tr>
                    <th>
                      <b>*</b>Leap Years
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={2}>
                      If leap year & Jan or Feb
                      <br />
                      then subtract 1
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const ArticleCentury = ({ children }) => {
  const [level, setLevel] = useState(null);

  return (
    <div className="-articleCentury">
      <div className="-inlineCentury">
        <CenturyTable includeCompact onChange={setLevel} />
      </div>
      {children}
      {level === 2 && (
        <div className="-centuryExplain">
          <b>Why only go back to the 1500s?</b>
          <br />
          The Gregorian calendar was first introduced in <b>1582</b> to replace
          the Julian calendar. The algorithm will not work correctly for dates
          prior to that year.
        </div>
      )}
    </div>
  );
};

const Tips = () => {
  const date = new Date();
  const year = date.getFullYear();
  const day = date.getDate();
  const month = date.getMonth();

  const yearCalc = getYearCalculation(year, false);

  const leapAdjustment = month < 2 && isLeapYear(year) ? -1 : 0;

  const finalCalc = day + MONTH_CODES[month] + yearCalc.answer + leapAdjustment;

  const yearTips = getYearTips(year, 0);

  const [isTipShown, setTipShown] = useState(getVisits() > 1);

  const isUsa = getIsUsa();

  const Practice = isUsa ? "Practice" : "Practise";
  const memorize = isUsa ? "memorize" : "memorise";
  const memorization = isUsa ? "memorization" : "memorisation";

  return (
    <div className="-extras">
      <TipSheet year={year} isShown={isTipShown} setShown={setTipShown} />

      <div className="-info">
        <p>
          It is much easier than it seems to calculate the day of the week. We
          simply calculate a number for each of the day, month, and year; add
          them together, and get the remainder after dividing by 7{" "}
          <i>
            (or subtract 7 as many times as you can, until the number you have
            is between 0 and 6)
          </i>
          .
        </p>
        <p>Your final number, from zero to six, then maps to the following:</p>
        <ul className="-weekdayList" dir={getLocaleIsRtl() ? "rtl" : null}>
          {[0, 1, 2, 3, 4, 5, 6].map((n) => (
            <li key={n}>
              {n} = {getLocaleLongWeekday(n)}
            </li>
          ))}
        </ul>
        <p>
          <b>Day Number</b>
          <br />
          This is just the day number. For example, today's date is the{" "}
          <em>{numToNth(day)}</em> of <em>{getLocaleLongMonth(month)}</em>, so
          the number for adding is <strong>{day}</strong>.
        </p>
        <p>
          <b>Month Number</b>
          <br />
          You will need to {memorize} the numbers below:
        </p>

        <Months small />

        <p>
          It's the only {memorization} you need to do, and fortunately it's only
          12 numbers. The "{Practice}" page has a special mode called "Month
          Part" that will help you {memorize} this.
          <br />
          In the table, you will see that the number for the current month of{" "}
          <em>{getLocaleLongMonth(month)}</em> is <em>{MONTH_CODES[month]}</em>,
          so the number for adding is <strong>{MONTH_CODES[month]}</strong>.
        </p>
        <p>
          <b>Year Number</b>
          <br />
          There is a calculation for this, but most of the time you can just{" "}
          {memorize} this for the whole year.{" "}
          {yearCalc.answer === 0 ? (
            <>
              The year {year} calculates to be <b>zero</b>, so for the rest of
              this year you can just forget this whole part.
            </>
          ) : (
            <>
              The year {year} calculates to be <b>{yearCalc.answer}</b>.
            </>
          )}
        </p>
        <p>
          For the years {yearTips[0]}-{yearTips[yearTips.length - 1]}, you could
          also {memorize} those, they are
          {isTipShown
            ? " shown in the tip sheet at the top of this page"
            : ""}{" "}
          <b>{yearTips.map(getYearCode).join(", ")}</b> respectively.
        </p>
        <p>
          For other years, the calculation is as follows:
          <br />
          Just look at the last two digits of the year, for example {year}, we
          consider just <b>{year % 100}</b>.<br />
        </p>
        <p>
          Take {year % 100}, divide it by four, and round down, then add it back
          to itself.
          <br />
          Eg. {yearCalc.digits}/4 = <b>{yearCalc.digitsDivideBy4}</b> (rounded
          down).
          <br />
          Adding this to itself we get <b>{yearCalc.digitsSum}</b> (
          {yearCalc.digits}+{yearCalc.digitsDivideBy4}).
        </p>
        <p>
          Now, we get the remainder after dividing by 7{" "}
          <i>
            (or&nbsp;subtract 7 as many times as you can, until the number you
            have is between 0 and 6)
          </i>
          .
        </p>
        <p>
          In our case of {yearCalc.digitsSum}, the remainder after division by 7
          is <strong>{yearCalc.answer}</strong> ({yearCalc.digitsSum}
          &nbsp;-&nbsp;7x
          {Math.floor(yearCalc.digitsSum / 7)}&nbsp;=&nbsp;{yearCalc.answer}).
        </p>
        <p>
          <b>Century Rule</b>
          <br />
          If our year is in the 2000s (2000-2099), then no special
          century rule is required.
          <br />
          If the year is in the 1900s (1900-1999), we need to do a
          special "century" step of adding <b>+1</b>.<br />
        </p>

        <ArticleCentury>
          <p>
            These are generally the only centuries we will need to deal with,
            but you can tap on the table to the right to see more.
          </p>
        </ArticleCentury>

        <p>
          <b>Leap Year Rule</b>
          <br />
          Finally, if the date we are calculating is in <b>January</b> or{" "}
          <b>February</b> of a leap year, then <b>subtract 1</b> to our final
          answer.{" "}
          {leapAdjustment ? (
            <>
              This applies to our current example, so we include the
              subtruction: <strong>&minus;{-leapAdjustment}</strong>.
            </>
          ) : (
            <>
              This does not apply to our current example, so we will skip this.
            </>
          )}
        </p>
        <p>
          <b>Adding it all up</b>
          <br />
          Our {leapAdjustment ? "four" : "three"} numbers are <b>{day}</b> +{" "}
          <b>{MONTH_CODES[month]}</b> + <b>{yearCalc.answer}</b>
          {leapAdjustment ? (
            <>
              {" "}
              &minus; <b>1</b>
            </>
          ) : (
            ""
          )}{" "}
          = <strong>{finalCalc}</strong>.
          <br />
          After dividing by 7 and taking the remainder we get{" "}
          <strong>{finalCalc % 7}</strong>.
          <br />
          The day is therefore{" "}
          <strong>{getLocaleLongWeekday(finalCalc % 7)}</strong>.
        </p>
        <hr />
        <p>
          <b>Calculating Dates</b>
          <br />
          The daily game includes two questions where you must calculate a date,
          eg. the first Wednesday of October, 2015. The&nbsp;way to calculate
          this is to first determine the weekday of{" "}
          {isUsa ? "Oct 1, 2015" : "1 Oct 2015"}, and then count up until you
          hit your first Wednesday{" "}
          <i>(you might find it easier to count on your fingers)</i>. To
          calculate the <i>third</i> Wednesday, just add 14 to your answer. To
          calculate the <i>last</i> Wednesday instead add 21 or 28, whichever
          fits.
        </p>
        <hr />
        <p>
          <b>Optional Extra Steps / Shortcuts</b>
          <br />
          &#x25cf; Since weekdays repeat every 7 days, if you have a day of the
          month that is 7 or higher, you can take the remainder after division
          by 7 <i>(or just keep subtracting 7)</i>. For example, if your day of
          the month is 23, you can just treat it like a 2.
          <br />
          <br />
          &#x25cf; Since the whole calendar generally repeats every 28 years, if
          you are doing a year calculation for any year where the last two
          digits are 28 or higher, you can subtract any multiple of 28 before
          calculating the year number. Although this sounds difficult, it's
          actually quite easy, just subtract 28, 56 or 84, whichever is the
          largest possible. The extra step makes the later calculation much
          easier.
        </p>
        <p>
          &#x25cf; Finally, for a very advanced technique, you might {memorize}{" "}
          the table of 28 numbers below so that you never need to manually
          calculate the year part at all. The cells represent the two-digits of
          the year, and the left column is the calculated year value.
        </p>
      </div>

      <YearCheat />

      <p className="-footnote">
        Note: this system of date determination was not invented by me. As far
        as I know techniques like this have been known for hundreds of years.
        Other systems have also been devised, such as the "Doomsday Rule", and
        you can read more about those online. You can use the "{Practice}" and
        "Play" page using whatever system you like most.
      </p>

      <Footer />
    </div>
  );
};

const YearCheat = () => {
  const _ = null;

  const rows = [
    [0, 6, _, 17, 23],
    [1, 7, 12, 18, _],
    [2, _, 13, 19, 24],
    [3, 8, 14, _, 25],
    [_, 9, 15, 20, 26],
    [4, 10, _, 21, 27],
    [5, 11, 16, 22, _],
  ];

  return (
    <div className="-yearCheat">
      <table className="-tipTable" dir={getLocaleIsRtl() ? "rtl" : null}>
        <thead>
          <tr>
            <th colSpan={6}>Year Quick Method</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <th>{index}</th>
              {row.map((n, index) => (
                <td key={index}>{n !== null && pad2(n)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TipsView;
